var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Component } from 'react';
import PropTypes from 'prop-types';
/** @public */
var propTypes = {
    children: PropTypes.node,
    /** fallback node to render when the component catches an error from a child */
    fallback: PropTypes.node,
    /**
     * function to log the error that occurred -
     * accepts a single parameter, an object `payload`
     */
    log: PropTypes.func.isRequired,
    /**
     * additonal data to be passed to the logger function when an error is caught
     */
    payload: PropTypes.object,
};
/**
 * ErrorBoundary implements React's `componentDidCatch` lifecycle hook
 *
 * Further reading: https://reactjs.org/docs/react-component.html#componentdidcatch
 *
 * @public
 */
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasError: false };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function () {
        return { hasError: true };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, info) {
        var _a = this.props, payload = _a.payload, log = _a.log;
        var componentStack = info.componentStack;
        var loggerPayload = __assign({ componentStack: componentStack, error: error }, payload);
        log(loggerPayload);
    };
    ErrorBoundary.prototype.render = function () {
        var hasError = this.state.hasError;
        var _a = this.props, fallback = _a.fallback, children = _a.children;
        if (hasError) {
            if (!fallback) {
                return null;
            }
            else {
                return fallback;
            }
        }
        return children;
    };
    return ErrorBoundary;
}(Component));
ErrorBoundary.defaultProps = {
    fallback: null,
    payload: {},
};
export default ErrorBoundary;
//# sourceMappingURL=ErrorBoundary.js.map